import { createSelector } from 'reselect'

export const getIsCardInMyBoard = (state, props) => {
  return state['view-card'].myBoard[props.cardContext.id].isCardInMyBoard
}

export const getMyBoard = (state, props) => {
  return state['view-card'].myBoard[props.cardContext.id].myBoard
}

export const getIsLoading = (state, props) => {
  return state['view-card'].myBoard[props.cardContext.id].isLoading
}

export const getIsLoaded = (state, props) => {
  return state['view-card'].myBoard[props.cardContext.id].isLoaded
}

export const getCurrentUserId = (state, props) => {
  return state.kanbo.currentUser.id
}

export default createSelector(
  [
    getIsCardInMyBoard,
    getMyBoard,
    getIsLoading,
    getIsLoaded,
    getCurrentUserId
  ],
  (
    isCardInMyBoard,
    myBoard,
    isLoading,
    isLoaded,
    currentUserId
  ) => ({
    isCardInMyBoard,
    myBoard,
    isLoading,
    isLoaded,
    currentUserId
  })
)
